import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const ProjectsActionsToggle = ({ project, t, handleClick }) => {
  return (
    <Form.Button
      onClick={(e) => {
        e.preventDefault();
        handleClick(project.id);
      }}
      text={t(project.active ? 'actions.deactivate' : 'actions.activate')}
      color={project.active ? 'outline-warning' : 'outline-info'}
      extraClassName={'btn-sm'}
      isLoading={project.isLoading}
    />
  );
};

export default translate()(ProjectsActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/components/list/actions/ProjectsActionsToggle.js